import { render, staticRenderFns } from "./CommonSection.vue?vue&type=template&id=25c8b1fc&scoped=true&"
import script from "./CommonSection.vue?vue&type=script&lang=js&"
export * from "./CommonSection.vue?vue&type=script&lang=js&"
import style0 from "./CommonSection.vue?vue&type=style&index=0&id=25c8b1fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8b1fc",
  null
  
)

export default component.exports